import type { ColumnConfig } from '@/components/datatable/dataTableTypes';

export const columns: ColumnConfig[] = [
  {
    field: 'id',
    truncateLength: 8,
    noWrap: true,
    align: 'left',
    sortable: false,
    hideInitial: true,
  },
  { field: 'editorName', align: 'left', sortable: false },
  { field: 'createdAt', type: 'datetime', align: 'left', sortable: false, hidden: true },
  { field: 'changedAt', type: 'datetime', align: 'left', sortable: false },
  { field: 'eventType', sortable: false, hideInitial: true },
  { field: 'changes', sortable: false, type: 'array' },
  { field: 'action', sortable: false, hideInitial: true },
];
